<template>
  <button :style="{ ...customStyles }" @click="handleClick">
    {{ text }}
  </button>
</template>

<script>
export default {
  name: 'CustomChartButton',
  props: {
    text: {
      type: String,
      required: true,
    },
    customStyles: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>

<style scoped>
button:not(:first-child) {
  margin-left: 10px;
}
button {
  padding: 10px 20px;
  border: 1px solid #64b4c8;
  background: #edf2f7;
  width: 80px;
  display: inline-block;
  white-space: nowrap;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  color: #475569;
  font-weight: 600;
  font-size: 0.75rem;
}

button:hover {
  opacity: 0.8;
}
</style>
